"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var MarkersRenderer_1 = require("../MarkersRenderer");
var attributesArrayToAttributes = function (attributesArray) {
    return attributesArray.reduce(function (accumulator, value, index) {
        var _a;
        return index % 2 !== 0
            ? __assign(__assign({}, accumulator), (_a = {}, _a[attributesArray[index - 1]] = value, _a)) : accumulator;
    }, {});
};
exports.default = (function (_a) {
    var createElement = _a.createElement, getAtomComponent = _a.getAtomComponent, getMarkupComponent = _a.getMarkupComponent;
    return function (_a) {
        var markups = _a.markups, atoms = _a.atoms;
        return function (_a) {
            var tagName = _a[1], markers = _a[2], attributes = _a[3];
            return createElement.apply(void 0, __spreadArrays([getMarkupComponent(tagName) ||
                    utils_1.throwError("Unhandled element: the markup section `'" + tagName + "'` has no corresponding handler."),
                attributesArrayToAttributes(attributes || [])], MarkersRenderer_1.default({ createElement: createElement, getAtomComponent: getAtomComponent, getMarkupComponent: getMarkupComponent })({
                markups: markups,
                atoms: atoms
            })(markers)));
        };
    };
});
